import { languageValidation } from "../..";
import { LocalizedSurveyText, SurveyQuestionType, SurveyQuestionTypes, } from "../../../DTOs";
import { basicValidation } from "../basicValidation";


export const surveyQuestionFieldValidation = {
    surveyQuestion:{
        
        index: (value: number) => basicValidation.validateInteger(value, 0, 100),
        move: (value: 'up' | 'down') => {
            if (!['up', 'down'].find(v => v === value))
                return false;
            return true;
        },
        invertScore: (value: boolean) => typeof value === 'boolean',

        indicators: (indicators: string[]) => {
            if (indicators === null || indicators === undefined || !Array.isArray(indicators))
                return false;
            
            if (indicators.length === 0)
                return true;
            
            if (!basicValidation.arrayStringsAreUnique(indicators))
                return false;
            
            return indicators.every(indicator => validateIndicator(indicator));
        },
        title: (text: string) =>  basicValidation.resourceText.isValid(text, false, 400),
        translations: (translations: LocalizedSurveyText[] | null) => {
            if(translations === null)
                return true;
            return languageValidation.validateLocalizedSurveyTexts(translations);
        },
            
        canComment:(value:boolean) => typeof value === 'boolean',
        type:(value:SurveyQuestionType) => validateType(value),
        scored:(value:boolean) => typeof value === 'boolean',
        conditionalDisplay: (value:{ triggerValues:string[] } | undefined) => {
            if (value === undefined)
                return true;
            if (value === null || typeof value !== 'object' || !Array.isArray(value.triggerValues))
                return false;
            if (value.triggerValues.length === 0)
                return false;
            if(!basicValidation.arrayStringsAreUnique(value.triggerValues))
                return false;
            return value.triggerValues.every(triggerValue => basicValidation.resourceId.isValid(triggerValue));
        }
    },

    surveyQuestionOption:{
        text: (value: string) => basicValidation.resourceText.isValid(value, false, 200),
        value: (value: string) => basicValidation.resourceId.isValid(value), // not an accident, we use resourceId for option values to ensure they are unique and can be used as keys
        score: (value: number) => [1,2,3,4,5].includes(value)
    }
}

function validateIndicator(indicator:string):boolean {
    return basicValidation.resourceText.isValid(indicator, false, 50);
}

function validateType(type:SurveyQuestionType):boolean {
    if(type === null || type === undefined || typeof type !== 'string')
        return false;

    const isValidType = Object.values(SurveyQuestionTypes).find(v => v === type) !== undefined;
    if(!isValidType)
        return false;
    
    return true;
}

